$(document).ready(function() {
//
});

window.onSubmit = function() {
    const contactForm = $("#mailchimpForm");
    const submitButton = $("#submitButton");
    sendMail(contactForm, submitButton)
}
window.onSubmitContact = function() {
    const contactForm = $("#contactForm");
    const submitButton = $("#submitContactButton");
    sendMail(contactForm, submitButton)
}

function sendMail(contactForm, submitButton) {
    if (contactForm.valid()){
        const url = contactForm.attr('action');
        const formData = contactForm.serialize();

        $.ajax({
            url: url,
            type: 'POST',
            dataType: 'json',
            data: formData,
            beforeSend: function(xhr) {
                $('#subscribeResponse').addClass('d-none').html("");
                setTimeout(() => {
                    submitButton.attr('disabled', 'disabled');
                }, 100);
                submitButton.addClass('disabled').prepend(`<div class="spinner-border spinner-border-sm mr-2"></div>`);
                $('.responseMessage').html('');
            },
            success: function(data) {
                $('#responseMessage').html(`<p>${data.html}<p>`);
                $('#pageModal').modal('show');
                submitButton.prop('disabled', false).removeClass('disabled').find('div:first').remove();
                contactForm.trigger("reset");
            },
            error: function(xhr,status,error) {
                const response = xhr.responseJSON;
                if(response.html) {
                    $('#subscribeResponse').toggleClass('d-none').html(response.html);
                }
                // $('#responseMessage').html('<p>Hiba az üzenet elküldése közben. Kérlek próbáld újra később!<p>');
                submitButton.prop('disabled', false).removeClass('disabled').find('div:first').remove();
            }
        })
            // .fail(function(data) {
            //     console.log(data.responseText.email)
            //     if(data.responseText.email) {
            //         $('#subscribeResponse').html(data.responseText.email);
            //     }
            //     // $('#responseMessage').html('<p>Hiba az üzenet elküldése közben. Kérlek próbáld újra később!<p>');
            //     submitButton.prop('disabled', false).removeClass('disabled').find('div:first').remove();
            // })
            .always(function() {
                submitButton.prop('disabled', false).removeClass('disabled').find('div:first').remove();
            });
    }
    else{
        contactForm[0].reportValidity();
    }
}
